<oui-accordion [expanded]="fileInfos && fileInfos.length > 0" class="padding-24 with-border rounded">
  <oui-accordion-header class="padding-vertical-8">
    <oui-accordion-title>
      @if (itemsCategory === 'operation') {
        <app-operation-accordion-title [operation]="operation" [index]="operationIndex" [showDetails]="true">
        </app-operation-accordion-title>
      }

      @if (itemsCategory === 'investisseur' || itemsCategory === 'co-investisseur') {
        <span class="subtitle-1"
          >Connaissance client - {{ itemsCategory === 'co-investisseur' ? 'Co-' : '' }}Investisseur :
        </span>
        <span class="body-1">{{ investisseur?.investisseurEntite?.displayName }}</span>
      }
      @if (itemsCategory === 'conseil') {
        <span class="subtitle-1">Conseil </span>
      }
    </oui-accordion-title>
  </oui-accordion-header>
  <div class="flex-vertical gap-16">
    @if (showBannerConnaissanceClient) {
      <oui-banner
        class="banner-help-documents"
        declination="alert"
        title="Merci de vérifier les documents de la connaissance client automatiquement importés des documents Investisseur."
        [showCloseButton]="false"></oui-banner>
    }

    @if (showBannerSouscription) {
      <oui-banner
        class="banner-help-documents"
        declination="alert"
        [title]="bannerSouscriptionTitle"
        [showCloseButton]="false"></oui-banner>
    }

    <div class="file-items-container">
      @for (fileInfo of fileInfos; track fileInfo; let eltIndex = $index) {
        <app-souscription-file-item
          [fileInfo]="fileInfo"
          [itemsCategory]="itemsCategory"
          [isFileLoading]="draftOperationService.isTryingAutoImport"
          [outdatedDocument]="fileInfo.outdatedDocument"
          (fileSelected)="displayFile(fileInfo)"
          (refreshOutdatedDocument)="refreshOutdatedDocument(fileInfo, $event)"
          (addFileClick)="onQuickUpload(eltIndex, $event)"
          (addFromInvestisseurDocs)="onAddFromInvestisseurDocs(eltIndex)">
        </app-souscription-file-item>
      }
    </div>
    @if (withGlobalAddFilesButton) {
      <span class="subtitle-2">Ajouter des documents supplémentaires</span>
    }
    <div class="">
      @if (withGlobalAddFilesButton) {
        <div class="global-add grid">
          <div class="card">
            <oui-file-uploader
              #u="ouiFileUploader"
              type="multi"
              accept=".pdf,.jpg,.jpeg,.png"
              [control]="globalSelectedFilesControl"
              (valueChange)="onQuickGlobalUpload($event)"
              [maxFileSize]="20">
              Glisser déposer ou ajouter <br />
              <span class="oui-link body-2" (click)="u.openFileDialog()"> depuis mon ordinateur </span>
            </oui-file-uploader>
          </div>
          <div class="or" aria-hidden="true">ou</div>
          <div class="card">
            <oui-fat-button label="Ajouter depuis les documents investisseur" (click)="onAddFromInvestorDocsGlobal()">
              <oui-icon name="backup" class="big-icon">backup</oui-icon>
            </oui-fat-button>
          </div>
          @if (isGlobalUploadInProgress) {
            <oui-loading size="small"></oui-loading>
          }
        </div>
      }
    </div>
    <div class="body-2 color-on-surface-medium">
      Formats acceptés : PDF, JPEG, PNG - Poids maximum 20 Mo par document.
    </div>
  </div>
</oui-accordion>
<ng-template #loading>
  <oui-loading size="small"></oui-loading>
</ng-template>
